var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "170px",
    viewBox: "0 0 130 170",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112,51.7 L130,30.3 C123.1,20.4 113.5,12.2 101.8,6.8 C66.2,-9.8 24,5.7 7.5,41.3 C-4.8,67.7 0.6,97.8 18.8,118.3 L89.1,34.6 C98.1,38.8 105.8,44.7 112,51.7 Z",
    id: "Path",
    fill: "#FC2361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,135.5 C32.7,131.3 25,125.4 18.8,118.4 L0.8,139.8 C7.7,149.7 17.3,157.9 29,163.3 C64.6,179.8 106.8,164.3 123.3,128.7 C135.6,102.3 130.2,72.2 112,51.7 L41.7,135.5 Z",
    id: "Path",
    fill: "#5CC7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,135.5 L112,51.7 C105.8,44.7 98.1,38.8 89.1,34.6 L18.8,118.3 C25,125.3 32.7,131.2 41.7,135.5 Z",
    id: "Path",
    fill: "#54205A"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2908b8daf6896a719f682282535e324.svg";
export { ForwardRef as ReactComponent };